export default __webpack_public_path__ + "static/media/moneta_today_logo.a9591456.svg";